import React from 'react'
import SyncManager from '../Components/Admin/SyncManager'

function SyncManagerPage() {
    return (
        <>
            <SyncManager />
        </>
    )
}

export default SyncManagerPage
